module.exports = __webpack_public_path__ + "static/media/gym.6a5709b7.png";